const days = {
  1: {
    letter: 'M',
    name: 'Monday',
    shorthand: 'Mon',
  },
  2: {
    letter: 'T',
    name: 'Tuesday',
    shorthand: 'Tue',
  },
  3: {
    letter: 'W',
    name: 'Wednesday',
    shorthand: 'Wed',
  },
  4: {
    letter: 'T',
    name: 'Thursday',
    shorthand: 'Thu',
  },
  5: {
    letter: 'F',
    name: 'Friday',
    shorthand: 'Fri',
  },
  6: {
    letter: 'S',
    name: 'Saturday',
    shorthand: 'Sat',
  },
  7: {
    letter: 'S',
    name: 'Sunday',
    shorthand: 'Sun',
  },
};

export default days;
